'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _reactDom = require('react-dom');

var _helpers = require('helpers');

var _utils = require('helpers/utils');

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SocialRowView: {
        displayName: 'SocialRowView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/SocialRow/default/SocialRowView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var SocialRowView = _wrapComponent('SocialRowView')(function (_Component) {
    (0, _inherits3.default)(SocialRowView, _Component);

    function SocialRowView() {
        (0, _classCallCheck3.default)(this, SocialRowView);
        return (0, _possibleConstructorReturn3.default)(this, (SocialRowView.__proto__ || (0, _getPrototypeOf2.default)(SocialRowView)).apply(this, arguments));
    }

    (0, _createClass3.default)(SocialRowView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props$product = this.props.product,
                name = _props$product.name,
                description = _props$product.description,
                pictures = _props$product.pictures,
                seoParams = _props$product.seoParams;

            var url = global.location.href; //.href - полный путь host - короткий
            var imgSrc = (0, _helpers.checkPicture)(pictures);
            description = description ? (0, _utils.stripTags)(description) : " ";
            if (description.length > 250) {
                description = description.substr(0, 250) + '...';
            }
            var myShare = this.refs.yandex_buttons;
            try {
                var share = Ya.share2(myShare, {
                    content: {
                        url: url,
                        title: name,
                        description: description,
                        image: imgSrc
                    },
                    theme: {
                        services: 'vkontakte,facebook,twitter,odnoklassniki'
                    }
                });
            } catch (e) {}
        }
    }, {
        key: 'render',
        value: function render() {
            return _react3.default.createElement('div', { className: 'social-row' });
        }
    }]);
    return SocialRowView;
}(_react2.Component));

exports.default = SocialRowView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialRow/default/SocialRowView.jsx
// module id = 1773
// module chunks = 0